<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4" >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombres/Email</label>
                <input
                  type="text" v-model="filters.name"
                  class="form-control h-55"
                  placeholder="Ingrese nombre"
                />
              </div>
            </div>
            
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Rol</label>
                <select v-model="filters.roleId"
                    class="form-select form-control h-55"
                    aria-label="Default select example"
                  >
                    <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                    <option :value="item.id" v-for="(item, i) of itemsRoles" :key="i" >{{item.name}}</option> 
                  </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select v-model="filters.isActive"
                    class="form-select form-control h-55"
                    aria-label="Default select example"
                  >
                    <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                    <option value="true">{{STATUS.ACTIVE}}</option>
                    <option value="false">{{STATUS.INACTIVE}}</option> 
                  </select>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button type="button" @click.prevent="getUsers(currentPage)" 
                  class="btn btn-outline-primary  py-1 px-3 fw-medium fs-14 hover-bg">
                  Buscar
                </button>
                <RouterLink to="/user/create">
                  <button type="button" class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg">
                    <span class="py-sm-1 d-block">
                      <span>Agregar Usuario</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
        
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col" >#</th>
                <th scope="col" class="text-center">Nombres</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Rol</th>
                <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">Creado<br> por</th>
                <th scope="col" class="text-center">Fecha <br>creación</th>
                <th scope="col" class="text-center">Modificado <br>por</th>
                <th scope="col" class="text-center">Fecha <br> modificación</th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in items" :key="item.id">
                <td>
                  {{
                      (index + 1) + (currentPage-1) * pageSize
                  }}
                </td>
                <td>{{item.firstName}} {{item.lastName}}</td>
                <td class="text-body">{{ item.email }}</td>
                <td class="text-body">{{ item.role.name }}</td>
                <td class="text-body text-center">
                  <span @click="confirmChangeStatus(item.id, item.isActive)"
                    class="badge bg-opacity-10 p-2 fs-12 fw-normal" role="button"
                    :class="computeStatusClass(item.isActive)"
                  >
                    {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE}}
                  </span>
                </td>
                <td class="text-body">{{ item.createdBy }}</td>
                <td class="text-body">{{ item.createdAtDateTimeString}}</td>
                <td class="text-body">{{ item.updatedBy }}</td>
                <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                <td  class="text-center">
                  <div class="">
                    <RouterLink :to="`/user/edit/${item.id}`"  >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                    
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination 
                :currentPage="currentPage"
                :pageSize="pageSize"
                :totalItems="totalItems"
                @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue"; 
import OverlayLoader from '@/components/Others/OverlayLoader.vue';
import Swal from 'sweetalert2';
import { useToast } from "vue-toastification";
import api from '@/services/api';
import {PAGINATION_ITEMS_PER_PAGE, STATUS, LABELS}  from "@/utils/constants";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Users",
  components: {
    Pagination,OverlayLoader 
  },
  setup() {
    
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
 
    const itemsRoles = ref<any[]>([]);
    const items = ref<any[]>([]);
    const filters = ref({
      name:'',
      roleId: null,
      isActive: null
		}); 

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    onMounted(async () => {
      
      await getRoles();
      await getUsers(currentPage.value);
      
    });

    const getRoles = async() => {
        try {
          const response = await api.get(`/common/roles`);
          itemsRoles.value = response.data;

        }catch(ex){
          console.error(ex);
        }
    };

    const getUsers = async(page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if(filters.value.name){
          params  = params + `&name=${filters.value.name}`
        }
        if(filters.value.roleId){
          params  = params + `&roleId=${filters.value.roleId}`
        }
        if(filters.value.isActive){
          params  = params + `&isActive=${filters.value.isActive}`
        }

        const response = await api.get(`/user?${params}`);
        
        items.value = response.data.list;
        totalItems.value = response.data.rows;
      } catch (error) {
        console.error(error);
      }finally{
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getUsers(currentPage.value)
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${status ? 'desactivar': 'activar'}</b> el Usuario?`, 
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? 'desactivar': 'activar'} `,
        cancelButtonText: 'Cancelar',
      });
      
      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          "id": id,
          "status": !status
        }

        const response: any = await api.put(`/user`, obj);
        
        if(response != 0){
          toast.success(`El usuario fue ${status ? "desactivado" : "activado" } con éxito.`, {
            timeout: 2000
          });
          fetchPage(currentPage.value)
        }else{
          toast.error(`El usuario no pudo ser ${status ? "desactivado" : "activado" }.`, {
            timeout: 2000
          });
        }
        isLoading.value = false;
      }
    };
    

    return {
      items, 
      itemsRoles,
      currentPage,
      pageSize,
      totalItems,
      STATUS,  LABELS, OverlayLoader,
      filters,
      isLoading,
      computeStatusClass,
      getUsers,
      fetchPage,
      confirmChangeStatus
    };
  },
});
</script>
